import script from "./product2View.vue?vue&type=script&setup=true&lang=js"
export * from "./product2View.vue?vue&type=script&setup=true&lang=js"

import "./product2View.vue?vue&type=style&index=0&id=8a2e52ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2e52ea"]])

export default __exports__